module.exports = __webpack_public_path__ + "static/media/the-sydney-wine-academy.b5e6dcbe.png";